import React from 'react';
import { IMaskInput } from 'react-imask';

/**
 * Componente de máscara para CNPJ
 * Formato: XX.XXX.XXX/XXXX-XX
 */
export const CNPJMask = React.forwardRef(function CNPJMask(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="00.000.000/0000-00"
      inputRef={ref}
      onAccept={value => onChange({ target: { name: props.name, value } })}
    />
  );
});

/**
 * Componente de máscara para CPF
 * Formato: XXX.XXX.XXX-XX
 */
export const CPFMask = React.forwardRef(function CPFMask(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="000.000.000-00"
      inputRef={ref}
      onAccept={value => onChange({ target: { name: props.name, value } })}
    />
  );
});

/**
 * Componente de máscara para CEP
 * Formato: XXXXX-XXX
 */
export const CEPMask = React.forwardRef(function CEPMask(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="00000-000"
      inputRef={ref}
      onAccept={value => onChange({ target: { name: props.name, value } })}
    />
  );
});
